/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates a histogram instance
 *
 * @module enervee_utils.histogram
 */
function histogramDirective() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            histogramData: '='
        },
        controllerAs: 'vm',
        controller: HistogramController,
        template: require('./histogramView.html')
    };
}

HistogramController.$inject = [
    '$log',
    '$scope',
    'HistogramService',
    'CmsContentService',
    'FiltersService',
    'AnalyticsService',
    'CategoriesService'
];
function HistogramController(
    $log,
    $scope,
    HistogramService,
    CmsContentService,
    FiltersService,
    AnalyticsService,
    CategoriesService
) {
    var NUMBER_OF_Y_AXIS_TICKS = 4;
    var HISTOGRAM_HEIGHT = 80;

    var vm = this;

    vm.trackHistogramViewed = trackHistogramViewed;

    vm.activeCategory = CategoriesService.getActiveCategory();

    vm.ticks = [];

    CmsContentService.retrieveCMSValue(vm, 'loadingText', 'results_page:histogram:loading_text');

    vm.scoreRangeCounts = HistogramService.getScoreRangeCounts($scope.histogramData);

    var MIN_ENERVEE_SCORE_FILTER_KEY = "min-enervee-score";
    var MAX_ENERVEE_SCORE_FILTER_KEY = "max-enervee-score";

    var lastDataQuantity = 0;
    var lastDataColor = null;
    var highestQuantity = 0;
    var allBackgroundColors = [];

    vm.HISTOGRAM_RANGE_FULL = "full";
    vm.HISTOGRAM_RANGE_0_TO_50 = "0-to-49";
    vm.HISTOGRAM_RANGE_50_TO_75 = "50-to-74";
    vm.HISTOGRAM_RANGE_75_TO_90 = "75-to-89";
    vm.HISTOGRAM_RANGE_90_TO_100 = "90-to-100";

    vm.histogramRange = vm.HISTOGRAM_RANGE_FULL;

    vm.histogramChart = null;

    var HISTOGRAM_SCORE_COLOR_RANGE = [
        {
            'score_min': 90,
            'score_max': 100,
            'css_class': 'is-ideal',
            'range': vm.HISTOGRAM_RANGE_90_TO_100
        },
        {
            'score_min': 75,
            'score_max': 89,
            'css_class': 'is-good',
            'range': vm.HISTOGRAM_RANGE_75_TO_90
        },
        {
            'score_min': 50,
            'score_max': 74,
            'css_class': 'is-average',
            'range': vm.HISTOGRAM_RANGE_50_TO_75
        },
        {
            'score_min': 0,
            'score_max': 49,
            'css_class': 'is-low',
            'range': vm.HISTOGRAM_RANGE_0_TO_50
        }
    ];

    vm.scoreStart = 0;
    vm.scoreEnd = 100;
    vm.scoreStartClass = HISTOGRAM_SCORE_COLOR_RANGE[0].css_class;
    vm.scoreEndClass = HISTOGRAM_SCORE_COLOR_RANGE[3].css_class;

    determineCurrentScoreRange();


    var productCountText = "";
    var enerveeScoreText = "";
    var chartOptions = null;
    CmsContentService.getMarketPlaceText('results_page:histogram:product_count').then(function(text) {
        productCountText = text;
        CmsContentService.getMarketPlaceText('results_page:histogram:enervee_score').then(function(text) {
            enerveeScoreText = text;

            var chartData = formatData($scope.histogramData);

            chartOptions = {
                scales: {
                    xAxes: [{
                        display: false,
                        barWidth: 4
                    }],
                    yAxes: [{
                        display: false,
                        ticks : {
                            beginAtZero : true,
                            callback : renderYAxisTicks
                        }
                    }]
                },
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem) {
                            var label = productCountText || '';

                            if (label) {
                                label += ': ';
                            }
                            label += tooltipItem.yLabel;
                            return label;
                        }
                    }
                }
            };

            renderWithAnimations(chartData);

            vm.filterScoreRange = function (range) {
                AnalyticsService.reportEvent('Histogram Engaged', {
                    filter: range
                });
                HistogramService.filterScoreRange(range);
            };
            vm.currentScoreRange = null;

        });
    });

    /**
     * Resets all the filters and gets back to the full histogram
     *
     */
    vm.back = function() {
        FiltersService.resetFilters();
    };

    /**
     * Determines the current score range based on the filters
     *
     */
    function determineCurrentScoreRange() {
        var currentFilters = FiltersService.currentFilters();

        if (MIN_ENERVEE_SCORE_FILTER_KEY in currentFilters) {
            var minScore = currentFilters[MIN_ENERVEE_SCORE_FILTER_KEY];

            for(var scoreRangeIndex in HISTOGRAM_SCORE_COLOR_RANGE) {
                var scoreRange = HISTOGRAM_SCORE_COLOR_RANGE[scoreRangeIndex];

                if (scoreRange.score_min === parseInt(minScore)) {

                    if (MAX_ENERVEE_SCORE_FILTER_KEY in currentFilters) {
                        var maxScore = currentFilters[MAX_ENERVEE_SCORE_FILTER_KEY];

                        if (scoreRange.score_max === parseInt(maxScore)) {
                            vm.currentScoreRange = scoreRange;
                            vm.histogramRange = scoreRange.range;
                        }
                    }
                    break;
                }
            }

        }
    }

    /**
     * Formats backend-data for chartjs to render properly
     *
     * @param data
     * @returns {{labels: Array, quantities: *, background_colors: Array}}
     */
    function formatData(data) {
        var backgroundColors = [];
        var labels = [];

        if (vm.currentScoreRange) {
            vm.scoreStart = vm.currentScoreRange.score_min;
            vm.scoreEnd = vm.currentScoreRange.score_max;
            vm.scoreStartClass = vm.currentScoreRange.css_class;
            vm.scoreEndClass = vm.currentScoreRange.css_class;
        }

        var quantities = [];
        var frameQuantities = [];

        for (var score=vm.scoreStart; score<=vm.scoreEnd; score++) {
            var backgroundColor = determineBackgroundColor(score);

            labels.push(enerveeScoreText + score);
            quantities.push(data[score]);
            if (data[score] > 0) {
                frameQuantities.push(quantities.slice(0));
            }

            /**
             * We need to set the highest possible bar value in all frames, so the scale of the chart wouldn't change. Therefore,
             * we will set the value of the last score of each frame to the max possible bar value and make it transparent,
             * and save its actual values in two directive level variables to replace later, so the real last score data will be rendered
             */
            if (score === vm.scoreEnd) {
                lastDataQuantity = data[score];
                lastDataColor = backgroundColor;
                backgroundColors.push('rgba(255, 255, 255, 0.0)');
            } else {
                backgroundColors.push(backgroundColor);
            }

            allBackgroundColors.push(backgroundColor);

            if (data[score] > highestQuantity) {
                highestQuantity = data[score];
            }

        }

        for (var i=0; i<frameQuantities.length; i++) {
            for (var j=frameQuantities[i].length; j<=vm.scoreEnd; j++) {
                frameQuantities[i][j] = 0;
            }
            frameQuantities[i][frameQuantities[i].length-1] = highestQuantity;
        }

        if (frameQuantities.length > 0) {
            quantities = frameQuantities[0];
        }

        return {
            'labels': labels,
            'quantities': quantities,
            'frame_quantities': frameQuantities,
            'background_colors': backgroundColors
        };
    }

    /**
     * Determines the background color of the given score, and adds it to
     *
     * @param score
     */
    function determineBackgroundColor(score) {
        var chartSelector = "canvas#histogram-graph";
        // Determining the background colors of the bars
        for (var j in HISTOGRAM_SCORE_COLOR_RANGE) {
            var colorRange = HISTOGRAM_SCORE_COLOR_RANGE[j];
            if (score >= colorRange.score_min) {
                var theColor = null;
                var tempClass = $(chartSelector).attr('class');
                $(chartSelector)
                    .addClass(colorRange.css_class)
                    .removeClass(function (idx) { // jshint ignore:line
                        theColor = $(this).css('color');
                    });
                $(chartSelector).attr('class', tempClass);

                return theColor;
            }
        }
    }

    /**
     * Renders the y-axis tick values
     *
     * @param value
     * @param index
     * @param values
     */
    function renderYAxisTicks(value, index, values){

        if (values.length === 0) {
            return;
        }

        var highestTick = values[0];

        for (var i=1; i<=NUMBER_OF_Y_AXIS_TICKS; i++) {
            vm.ticks[i] = Math.round(i * (highestTick/NUMBER_OF_Y_AXIS_TICKS));
        }
    }

    /**
     * Renders the histogram based on the given formatted data
     *
     * @param chartData
     */
    function render(chartData) {
        var graph = document.getElementById("histogram-graph");
        var ctx = graph.getContext('2d');
        vm.histogramChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: chartData.labels,
                datasets: [{
                    label: 'Product count',
                    data: chartData.quantities,
                    backgroundColor: chartData.background_colors,
                    borderWidth: 0
                }]
            },
            options: chartOptions
        });

        $(graph).css('height', HISTOGRAM_HEIGHT);
    }

    /**
     * Runs the histogram animations recursively and then renders the final bar values
     *
     * @param chartData
     * @param frame
     */
    function runAnimation(chartData, frame) {
        var minIntervalLength =  1000 / chartData.frame_quantities.length;
        var maxIntervalLength = minIntervalLength * 3;
        var intervalDuration = Math.random() * (maxIntervalLength - minIntervalLength) + minIntervalLength;

        window.setTimeout(function() {

            if (frame < chartData.frame_quantities.length) {
                vm.histogramChart.data.datasets[0].data = chartData.frame_quantities[frame];

                /**
                 * If it is the last frame, then we need to set the frame data (which is set to max quantity on purpose)
                 * to the actual last frame values which we saved earlier, so we will change the quantity and then
                 * after a delay the color. Otherwise, we just change the whole frame.
                 */
                if (frame === (chartData.frame_quantities.length - 1)) {
                    var lastData = vm.histogramChart.data.datasets[0].data.length-1;
                    vm.histogramChart.data.datasets[0].data[lastData] = lastDataQuantity;
                    vm.histogramChart.update();

                    window.setTimeout(function() {

                        for (var i = 0; i < vm.histogramChart.data.datasets[0].backgroundColor.length; i++) {
                            vm.histogramChart.data.datasets[0].backgroundColor[i] = allBackgroundColors[i];
                        }

                        vm.histogramChart.update();
                        runAnimation(chartData, frame+1);
                    }, 800);

                } else {
                    vm.histogramChart.update();
                    runAnimation(chartData, frame+1);
                }
            }

        }, intervalDuration);
    }

    /**
     * Renders the animation of the bars and then the actual values of the bars
     *
     * @param chartData
     */
    function renderWithAnimations(chartData) {

        if (chartData.frame_quantities.length > 0) {
            render(chartData);
            runAnimation(chartData, 1);
        }

    }

    function trackHistogramViewed() {
        AnalyticsService.reportEvent('Histogram Viewed', {
            product_count_low: vm.scoreRangeCounts[50],
            product_count_average: vm.scoreRangeCounts[75],
            product_count_good: vm.scoreRangeCounts[90],
            product_count_ideal: vm.scoreRangeCounts[100]
        });
    }
}

module.exports = histogramDirective;
